<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="用户权限管理" CMname="模块管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
								<el-option label="模块名称" value="moduleName"></el-option>
								<el-option label="模块代码" value="moduleCode"></el-option>
								<el-option label="模块地址" value="moduleUrl"></el-option>
							</el-select>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" >查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')">删除</el-button>
					<el-button type="primary" icon="fa fa-external-link" size="small" v-if="false">导出Excel</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="moduletable" @cell-click="cellclick" @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left" >
				</el-table-column>
				<el-table-column prop="moduleName" label="模块名称" width="180">
				</el-table-column>
				<el-table-column prop="moduleCode" label="模块代码" width="200">
				</el-table-column>
				<el-table-column prop="moduleIcon" label="模块Icon" width="180">
				</el-table-column>
				<el-table-column prop="moduleUrl" label="模块地址">
				</el-table-column>
				<el-table-column prop="parentName" label="父级模块" width="180">
				</el-table-column>
				<el-table-column prop="creationDate" label="创建时间" width="180" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="100">
				</el-table-column>
				<el-table-column prop="sort" label="排序" width="50">
				</el-table-column>
				<el-table-column label="状态" width="70" align="center">
					<template slot-scope="scope">
						<el-tag  :type="scope.row.status?'primary':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small" v-if="isHadFun('Update')">编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small" v-if="isHadFun('Delete')">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'module',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:10,
					moduleName:"",
					moduleCode:"",
					moduleUrl:""
				},
				tableData:[],
				total:0,
				loading:true,
				selectionRows:[],
				selectfield:"moduleName",
				keyword:"",
			}
		},
		methods:{
			onSubmit(){
				this.searchform.moduleName="";
				this.searchform.moduleCode="";
				this.searchform.moduleUrl="";
				this.searchform[this.selectfield]=this.keyword;
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Rowview(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/system/module/view/'+val.moduleId});
			},
			RowEdit(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/system/module/edit/'+val.moduleId});
			},
			Rowdelete(val){
				this.$confirm("确定要删除 '"+val.moduleName+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "delete",
                        url:this.$api.system.module+"/"+val.moduleId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			Addclick(){
				this.$router.push({path:'/system/module/add/',});
			},
			editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message({message:"只能操作一行数据",type:"warning"});
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/system/module/edit/'+this.selectionRows[0].moduleId});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "delete",
                        url:this.$api.system.module+"/"+myrow.moduleId});
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			cellclick(row, column, cell, event){
				this.$refs.moduletable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			initData(){
				var Vuethis=this;
				this.loading=true;
				this.$hrraxios.get(this.$api.system.moduleList, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.tableData=data.Data.List;
						Vuethis.total=data.Data.Total;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			}
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			next();
		},
		created(){
			this.$common.getFunListByMCode(this,"SystemModule",()=>{
				var vuethis=this;
				document.onkeydown = function(e) {
					var key = window.event.keyCode;
					if (key == 13) {
						if(vuethis.keyword!=""){
							vuethis.onSubmit();
						}
					}
				};
				this.initData();
			});
		}
	}
</script>
<style>
.input-with-select {
	width: 110px;
}
</style>